import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './NewsSection.css';

const NewsSection = ({ section }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      const response = await api.get('/news/', { params: { page_size: 3, featured: true } });
      const newsData = response.data.results || response.data;
      setNews(Array.isArray(newsData) ? newsData : []);
    } catch (error) {
      console.error('Error loading news:', error);
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="news-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (news.length === 0) return null;

  return (
    <section className="news-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        <Row className={news.length < 3 ? 'justify-content-center' : ''}>
          {news.map(item => (
            <Col key={item.id} lg={4} md={6} sm={12} className="d-flex">
              <Card className="news-card">
                {item.featured_image && (
                  <Card.Img 
                    variant="top" 
                    src={getMediaUrl(item.featured_image)} 
                    alt={item.title}
                  />
                )}
                <Card.Body>
                  <Card.Text className="text-muted small">
                    <i className="far fa-calendar-alt me-2"></i>
                    {moment(item.published_date).format('MMMM DD, YYYY')}
                  </Card.Text>
                  <Card.Title>
                    <Link to={`/news/${item.slug}`}>{item.title}</Link>
                  </Card.Title>
                  <Card.Text>
                    {item.summary || item.content.replace(/<[^>]*>/g, '').substring(0, 140)}...
                  </Card.Text>
                  <Link to={`/news/${item.slug}`} className="btn btn-outline-primary btn-sm">
                    Read More <i className="fas fa-arrow-right ms-1"></i>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-4">
          <Link to="/news" className="btn btn-primary">
            View All News <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default NewsSection;
